/* tslint:disable */
import { Fragment, useContext } from "react";
import AlertContext from "../store/Alert/AlertContext";
import { useSnackbar } from "notistack";
import { IconButton } from "@material-ui/core";
import CancelIcon from '@material-ui/icons/Cancel';
type Color = "success" | "info" | "warning" | "error";
const Alerts = () => {
  const { alert } = useContext<any>(AlertContext);
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();

  function Alerts(myalert: {id: string, err: Color | undefined; sucessmsg: string, autoHideDuration?: number } ) {
    enqueueSnackbar(myalert.sucessmsg, {
      autoHideDuration: myalert.autoHideDuration ?? 5000,
      variant: myalert.err,
      preventDuplicate: true,
      key: myalert.id,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      action: (key) => (
        <Fragment>
            <IconButton   size='small' onClick={() => closeSnackbar(key)}>
               <CancelIcon style={{color:"white"}} />
            </IconButton>
        </Fragment>
    )
    });
  }

  return (
    alert !== null &&
    alert.length > 0 &&
    alert.map(
      (myalert: { id: string, err: Color | undefined; sucessmsg: string, autoHideDuration?: number }) =>
        Alerts(myalert)
    )
  );
};

export default Alerts;
